/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IZoomToCodeDropDownFunctionScope extends angular.IScope {
        mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        mapFunctionConfiguration: Wars.Domain.Model.Gis.MapFunctionConfiguration;
        dropdownOptions: models.CodeDropDownItem[];
        codeChanged: any;
        selectedCode: string;
    }

    export class ZoomToCodeDropDownFunction implements IDirective {
        constructor() {

        }

        public templateUrl = "./app/views/directives/gis/mapFunction/zoomToCodeDropDownFunction.html";
        public restrict: string = "E";
        public controller = [
            "$scope", 'applicationCodeService', 'esriMapService',
            ZoomToCodeDropDownFunctionController
        ];
        public controllerAs = "controller";
        public scope: any = {
            mapConfiguration: "=",
            mapFunctionConfiguration: "="
        };


        public link($scope: IZoomToCodeDropDownFunctionScope, element: JQuery, attrs: ng.IAttributes) {

        }
    }

    export class ZoomToCodeDropDownFunctionController {

        constructor(private $scope: IZoomToCodeDropDownFunctionScope,
            private applicationCodeService: services.ApplicationCodeService,
            private esriMapService: services.EsriMapService) {

            $scope.codeChanged = () => this.codeChanged();
            this.loadDropDown();
        }

        private codeChanged() {
            console.log(this.$scope.selectedCode);

            var uniqueId = this.$scope.mapFunctionConfiguration.zoomToQueryConfiguration.placeHolderForInput
                .placeHolderUniqueIdentifier;

            var placeHolderDict = {};
            placeHolderDict[uniqueId] = this.$scope.selectedCode;

            this.esriMapService.queryMapService(this.$scope.mapFunctionConfiguration.zoomToQueryConfiguration
                .esriQueryConfiguration,
                placeHolderDict).then(r => {
                if (r && r.features) {
                    let geoJsonLayer = L.geoJSON(r, null);
                    //this.esriMapService.createGeoJsonLayer(r.features[0], r.geometryType);
                    //console.log(geoJsonLayer.getBounds());

                    GisMapController.currentMap.fitBounds(geoJsonLayer.getBounds());
                }
            });

        }

        private loadDropDown() {
            this.applicationCodeService.getSystemLevelApplicationCodesForExecution(
                this.$scope.mapFunctionConfiguration.dropdownCodeGroup_id,false).then((applicationCodes) => {
                this.$scope.dropdownOptions = this.applicationCodeService
                    .buildCodeDropDownOptions(applicationCodes, true, null);
            });
        }

    }
}

warsApp.registerDirective('ZoomToCodeDropDownFunction', []);